/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_Sign_InInputs */

const en_landing_nav_sign_in = /** @type {(inputs: Landing_Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const pl_landing_nav_sign_in = /** @type {(inputs: Landing_Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Landing_Nav_Sign_InInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_nav_sign_in = /** @type {((inputs?: Landing_Nav_Sign_InInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_Sign_InInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_nav_sign_in(inputs)
	return en_landing_nav_sign_in(inputs)
});